// TODO: change to /blog as part of new blog launch
const blogBasePath = '/blog-new'

const femRoutes = {
  home: '/',
  personalBanking: '/personal-banking',
  about: '/about',
  datePicker: '/public/date-picker',
  ecomLp: '/e',
  api: '/api',
  bankAccounts: '/bank-accounts',
  contact: '/contact',
  credit: '/credit',
  treasuryContact: '/contact/treasury',
  contactPartnerships: '/contact/partnerships',
  contactSales: '/contact/sales',
  ecommerce: '/ecommerce',
  faq: '/faq',
  financialWorkflows: '/financial-workflows',
  accountingAutomations: '/accounting-automations',
  blogHomepage: blogBasePath,
  blogIndex: `${blogBasePath}/search`,
  blogTag: (tag: string) => `${blogBasePath}/search?tag=${tag}`,
  blogArticle: (articleSlug: string) => `${blogBasePath}/${articleSlug}`,
  blogCategory: (categorySlug: string) =>
    `${blogBasePath}/categories/${categorySlug}`,
  blogTopic: (topicSlug: string) => `${blogBasePath}/topics/${topicSlug}`,
  billPay: '/bill-pay',
  howItWorks: '/how-mercury-works',
  investorIndex: '/investor-database',
  investorDetails: (investorCallsign: string) =>
    `/investor-database/${investorCallsign}`,
  investorFundDetails: (fundCallsign: string) =>
    `/investor-database/fund/${fundCallsign}`,
  jobs: '/jobs',
  job: (job: string): string => `/jobs/${job}`,
  lifeScience: '/life-science',
  northstar: '/northstar',
  partnerships: '/partnerships',
  perks: '/perks',
  perksDetails: (slug: string) => `/perks/${slug}`,
  pricing: '/pricing',
  raise: '/raise',
  raiseFounderCommunity: '/raise/founder-community',
  raiseInvestorConnect: '/raise/investor-connect',
  safe: '/safe',
  softwareStackIndex: '/raise/software-stack',
  softwareStackCategory: (categoryId: string) =>
    `/raise/software-stack/categories/${categoryId}`,
  softwareStackTool: (toolId: string) => `/raise/software-stack/tools/${toolId}`,
  saas: '/saas',
  security: '/security',
  spheresUpdatesForm: '/spheres/subscribe',
  treasury: '/treasury',
  vcFunds: '/vc-funds',
  ventureDebt: '/venture-debt',
  web3: '/web3',
  ycInterviews: '/ycmocks',
} as const

const legalRoutes = {
  accountantTerms: '/legal/accountant-terms',
  achAuthorization: '/legal/ach-authorization',
  // bbva page is only available to certain logged-in orgs, otherwise user gets redirected,
  // so we don't want this to be included on our sitemap
  bbva: '/legal/bbva',
  // https://mercurytechnologies.slack.com/archives/C04TZE0B2E6/p1680807487940479?thread_ts=1680276390.559059&cid=C04TZE0B2E6
  cashbackDisclosure: '/legal/cashback-disclosure',
  choice: '/legal/choice',
  choicePersonalBanking: '/legal/choice-personal',
  column: '/legal/column',
  consumerPrivacy: '/legal/consumer-privacy',
  customerPerksDisclosure: '/legal/customer-perks-disclosure',
  customerReferralAgreement: '/legal/referrals',
  esign: '/legal/esign',
  evolve: '/legal/evolve',
  financialWorkflows: '/legal/financial-workflows',
  ioChargeCardAgreement: '/legal/io-charge-card-agreement',
  io2percentCashbackPromotion: '/legal/io-2percent-cashback-promotion',
  patriotAct: '/legal/patriot-act',
  payment: '/legal/payment',
  privacy: '/legal/privacy',
  referralPartners: '/legal/referral-partners',
  subpoenaLawEnforcementRequests: '/legal/subpoena-law-enforcement-requests',
  terms: '/legal/terms',
} as const

export const internalLinks = {
  ...femRoutes,
  legal: legalRoutes,
} as const
